import { useEffect, useState } from 'react';

export default function QRPage() {
  const [qrUrl, setQrUrl] = useState('');
  const [targetUrl, setTargetUrl] = useState('');

  useEffect(() => {
    // Prevent search engines from indexing this utility page
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { meta.remove(); };
  }, []);

  useEffect(() => {
    const url = 'https://www.rulerlogistics.com';
    setTargetUrl(url);
    const encoded = encodeURIComponent(url);
    setQrUrl(`https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encoded}&bgcolor=ffffff&color=1a1a2e&margin=20`);
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-8 font-sans">

      {/* Print button - hidden when printing */}
      <div className="print:hidden mb-8 text-center">
        <p className="text-gray-500 text-sm mb-4">Odštampaj ili screenshot-uj QR kod i zalijepi ga gdje god želiš!</p>
        <button
          onClick={handlePrint}
          className="bg-[#D4A017] text-white px-8 py-3 rounded-full font-bold text-sm hover:bg-[#b8880f] transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
        >
          <i className="ri-printer-line"></i>
          Štampaj QR kod
        </button>
      </div>

      {/* Printable card */}
      <div className="bg-white rounded-3xl shadow-xl p-10 max-w-sm w-full text-center print:shadow-none print:rounded-none print:p-8">

        {/* Logo */}
        <img
          src="https://public.readdy.ai/ai/img_res/7ccc49fe-77a5-4275-9666-278e2d510b1b.png"
          alt="Ruler Logistics LLC"
          className="h-24 w-auto object-contain mx-auto mb-6"
        />

        {/* Headline */}
        <h1 className="text-[#1a1a2e] font-extrabold text-xl mb-1">Vozač tražiš posao?</h1>
        <p className="text-[#D4A017] font-bold text-base mb-6">Prijavi se odmah!</p>

        {/* QR Code */}
        <div className="flex items-center justify-center mb-6">
          {qrUrl ? (
            <img
              src={qrUrl}
              alt="QR kod - Ruler Logistics prijava"
              className="w-56 h-56 rounded-xl"
            />
          ) : (
            <div className="w-56 h-56 bg-gray-100 rounded-xl flex items-center justify-center">
              <span className="text-gray-400 text-sm">Učitavanje...</span>
            </div>
          )}
        </div>

        {/* Scan instruction */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-qr-scan-2-line text-[#D4A017] text-lg"></i>
          </div>
          <span className="text-gray-500 text-sm font-medium">Skeniraj kamerom telefona</span>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-100 pt-5 mt-2">
          <p className="text-gray-800 font-bold text-sm">Ruler Logistics LLC</p>
          <p className="text-gray-400 text-xs mt-1">Chicago, Illinois, USA</p>
          <p className="text-gray-400 text-xs mt-1">+1 (630) 202-4180</p>
          <p className="text-[#D4A017] text-xs mt-1 font-semibold">rulerlogistics@gmail.com</p>
        </div>

        {/* URL small text */}
        <p className="text-gray-300 text-[10px] mt-4 break-all">{targetUrl}</p>
      </div>

    </div>
  );
}
